<template >
  <div class="ly-card message-record">
    <div class="lf">
      <h3>用户组</h3>
      <ul>
        <li
          v-for="item in userGroup"
          :key="item.id"
          @click="clickItem(item)"
          :class="item.id === curItem.id && 'active'"
        >{{item.group_name}}</li>
      </ul>
    </div>
    <div class="rg" v-if="curItem.id">
      <div class="search-hd">
        <div class="fr">
          <el-input placeholder="发送人" v-model="searchFormData.send_people"></el-input>
          <el-input placeholder="使用模板" v-model="searchFormData.use_template"></el-input>
          <el-date-picker
            v-model="searchFormData.date"
            type="date"
            placeholder="发送时间"
            value-format="yyyy-MM-dd"
          ></el-date-picker>
          <el-button type="primary" @click.native="search">查询</el-button>
        </div>
      </div>
      <ly-table
        :getTableData="getTableData"
        :tableHeader="tableHeader"
        :searchFormData="searchFormData"
        ref="lyTable"
      >
        <template v-slot:action="row">
          <el-button @click="infRow(row)" type="text" size="mini">详情</el-button>
          <el-button @click="retryRow(row)" type="text" size="mini">再发一次</el-button>
          <el-button @click="failTryRow(row)" type="text" class="el-button--danger" size="mini">失败重发</el-button>
        </template>
        <template v-slot:send_fail="row">{{row.send_people_num - row.send_success_num}}</template>
      </ly-table>
    </div>
    <el-dialog title="发送详情" :visible.sync="dialogVisible" width="800px">
      <div class="record-content-detail">
        <span class="p-r-20">
          <strong>发送时间：</strong> xx
        </span>
        <span>
          <strong>发送人：</strong> xx
        </span>
        <div class="p-t-10">
          <strong>短信内容：</strong>xxx
        </div>
        <ly-table
          :getTableData="getTableDataDetail"
          :tableHeader="tableHeaderDetail"
          :searchFormData="searchFormDataDetail"
          ref="lyTableDetail"
        ></ly-table>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { DatePicker, Dialog, Input } from 'element-ui';
import { message } from '@/api';
import LyTable from '@/components/LyTable';

export default {
  name: 'MessageRecord',
  components: {
    ElDialog: Dialog,
    LyTable,
    ElInput: Input,
    ElDatePicker: DatePicker
  },
  data() {
    return {
      template_name: '',
      curItem: {},
      dialogVisible: false,
      curTmp: '',
      getTableData: message.smsRecordList,
      searchFormData: {
        send_people: '',
        use_template: '',
        date: ''
      },
      tableHeader: [
        {
          value: 'send_time',
          name: '发送时间'
        },
        {
          value: 'template_code',
          name: '使用模板'
        },
        {
          value: 'real_name',
          name: '发送者'
        },
        {
          value: 'send_people_num',
          name: '发送人数'
        },
        {
          value: 'send_success_num',
          name: '成功人数'
        },
        {
          value: 'send_fail',
          name: '失败人数'
        },
        {
          value: 'action',
          name: '操作',
          option: {
            width: '170px'
          }
        }
      ],
      userGroup: [],
      // 详情
      getTableDataDetail: message.smsRecordListDetail,
      searchFormDataDetail: {},
      tableHeaderDetail: [
        {
          value: 'a',
          name: '学员姓名'
        },
        {
          value: 'b',
          name: '家长姓名'
        },
        {
          value: 'c',
          name: '家长电话'
        },
        {
          value: 'd',
          name: '班级名称'
        },
        {
          value: 'e',
          name: '发送状态'
        }
      ]
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    async init() {
      message.smsUserGroup().then(res => {
        // 用户分组
        if (res && res.data) {
          this.userGroup = res.data.user_group_list;
        }
      });
    },
    clickItem(item) {
      this.curItem = item;
      this.searchFormData = {
        group_id: item.id,
        send_people: '',
        use_template: '',
        date: ''
      };
      this.$nextTick(() => {
        this.search();
      });
    },
    search() {
      this.$refs.lyTable.setData();
    },
    infRow(row) {
      this.curList = { ...row };
      this.searchFormDataDetail.sms_send_id = row.id;
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.lyTableDetail.setData();
      });
    },
    retryRow() {},
    failTryRow() {}
  }
};
</script>
<style lang="less">
.message-record {
  display: flex;
  height: calc(100vh - @navBarTopHeight - @navBarTagsHeight - 10px);
  overflow: auto;
  .message-content {
    margin-left: 10px;
  }
  .lf {
    width: 220px;
    height: 100%;
    background: #fff;
    border-right: 1px solid #ccc;
    overflow: auto;
    position: relative;
    padding-bottom: 40px;
    padding-right: 10px;
    h3 {
      border-bottom: 1px solid #ccc;
      padding-bottom: 10px;
    }
    .btn-bottom {
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      margin: auto;
      text-align: center;
    }
    ul {
      padding-left: 10px;
      li {
        list-style: none;
        display: flex;
        cursor: pointer;
        font-size: 15px;
        padding: 10px 5px;
        align-items: center;
        border-bottom: 1px solid #ccc;
        border-radius: 2px;
        transition: background 0.3s, color 0.3s;
        &.active {
          color: #fff;
          background: @main-blue;
        }
      }
    }
  }
  .rg {
    flex: 1;
    margin-left: 10px;
    .search-hd {
      border-bottom: 1px solid #ccc;
      overflow: hidden;
      margin-top: 20px;
      padding-bottom: 20px;
      .el-input {
        width: 160px;
        margin-right: 10px;
      }
    }
  }
}
</style>
